import { render, staticRenderFns } from "./learn-body.vue?vue&type=template&id=548729f3&scoped=true&"
import script from "./learn-body.vue?vue&type=script&lang=js&"
export * from "./learn-body.vue?vue&type=script&lang=js&"
import style0 from "./learn-body.vue?vue&type=style&index=0&id=548729f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548729f3",
  null
  
)

export default component.exports